import cx from 'classnames';
import { parseToDayMonthFormat } from '@shared/utils/dateFormatters';
import { pluralizer } from '@shared/utils/pluralizer';
import { ISOTimeTo12HourTime } from '@utils/time';
import { useRestaurantContext } from 'webReservations/context/RestaurantContext';
import typography from '~styles/typography.scss';
import styles from './CheckoutReservationDetails.scss';

export interface CheckoutReservationDetailsProps {
  date: string;
  guestCount: number;
  time: string;
  displayName: string | null;
}

export const CheckoutReservationDetails = ({
  date,
  guestCount,
  time,
  displayName,
}: CheckoutReservationDetailsProps) => {
  const { restaurantDetails } = useRestaurantContext();
  const formattedDate = parseToDayMonthFormat(date);
  const formattedTime = ISOTimeTo12HourTime(time);
  return (
    <div data-testid="checkout-reservation-details">
      <div className={cx(styles.row, typography.h5)}>
        <div>{restaurantDetails.name}</div>
        <div>{pluralizer('Guest', guestCount)}</div>
      </div>
      <div className={cx(styles.row, typography.c3)}>
        <div className={styles.publicName}>{displayName}</div>
        <div className={styles.subText}>
          {`${formattedDate}, ${formattedTime}`}
        </div>
      </div>
    </div>
  );
};
